import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=0f5a78a1&scoped=true&"
import script from "./Welcome.vue?vue&type=script&lang=ts&"
export * from "./Welcome.vue?vue&type=script&lang=ts&"
import style0 from "./Welcome.vue?vue&type=style&index=0&id=0f5a78a1&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5a78a1",
  null
  
)

export default component.exports